import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const exampleColumns = ['Product', 'Category', 'Price', 'Seller', 'Link', 'Status'];

const exampleRows = [
  ['Retro Runner', 'Shoes', '¥198', 'Seller A', '#', 'In stock'],
  ['Box Logo Tee', 'T-Shirts', '¥89', 'Seller B', '#', 'Checking'],
  ['Cargo Pants', 'Pants', '¥159', 'Seller C', '#', 'In stock'],
  ['Crossbody Bag', 'Bags', '¥129', 'Seller D', '#', 'Sold out'],
];

export default function GuideSection() {
  const { t } = useTranslation();

  return (
    <section className="bg-background-100/60">
      <div className="mx-auto max-w-content px-4 md:px-6 py-12 md:py-16">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            {t('guide.title')}
          </h2>
          <p className="mt-3 text-sm text-foreground-600 md:text-base">{t('guide.lead')}</p>
        </div>

        <div className="mx-auto mt-10 grid max-w-5xl grid-cols-1 gap-6 lg:grid-cols-2">
          <div className="space-y-4 text-sm leading-relaxed text-foreground-700">
            <p>
              When you browse for finds, the amount of information can add up quickly — product names,
              prices, seller details, direct links and shipping estimates. A dedicated Basetao
              spreadsheet turns that scattered data into a clear, sortable overview.
            </p>
            <p>
              The most useful sheets include a <strong>product name</strong>, a <strong>category</strong>,
              the <strong>price</strong>, a <strong>seller</strong>, the <strong>direct link</strong> and a <strong>status</strong> column so you always know what is in stock, still being checked or
              already sold out.
            </p>
            <p>
              By keeping every find in one place, you can compare similar items side by side, spot price
              differences between sellers, and share your list with others before deciding what to buy.
            </p>
            <Link
              to="/articles/basetao-spreadsheet/"
              className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 hover:bg-primary-600 transition-colors"
            >
              {t('guide.readFullGuide')}
              <i className="ri-arrow-right-line text-sm" />
            </Link>
          </div>

          <div className="rounded-lg border border-background-200/70 bg-background-50 p-4">
            <p className="mb-3 text-xs font-medium text-foreground-500">
              {t('guide.exampleLabel')}
            </p>
            <div className="overflow-x-auto">
              <table className="w-full min-w-[440px] text-left text-sm">
                <thead>
                  <tr className="border-b border-background-200/70 text-xs text-foreground-500">
                    {exampleColumns.map((col) => (
                      <th key={col} className="py-2 pr-3 font-medium whitespace-nowrap">
                        {col}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {exampleRows.map((row) => (
                    <tr key={row[0]} className="border-b border-background-100">
                      {row.map((cell, i) => (
                        <td
                          key={i}
                          className={`py-2.5 pr-3 whitespace-nowrap ${
                            i === 0 ? 'font-medium text-foreground-800' : 'text-foreground-600'
                          }`}
                        >
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}